const size = [
  "3xs",
  "2xs",
  "xs",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl",
  "3xl"
] as const

export default {
  "slots": {
    "root": "tw:inline-flex tw:items-center tw:justify-center tw:shrink-0 tw:select-none tw:rounded-full tw:align-middle tw:bg-elevated",
    "image": "tw:h-full tw:w-full tw:rounded-[inherit] tw:object-cover",
    "fallback": "tw:font-medium tw:text-muted tw:truncate",
    "icon": "tw:text-muted tw:shrink-0"
  },
  "variants": {
    "size": {
      "3xs": {
        "root": "tw:size-4 tw:text-[8px]"
      },
      "2xs": {
        "root": "tw:size-5 tw:text-[10px]"
      },
      "xs": {
        "root": "tw:size-6 tw:text-xs"
      },
      "sm": {
        "root": "tw:size-7 tw:text-sm"
      },
      "md": {
        "root": "tw:size-8 tw:text-base"
      },
      "lg": {
        "root": "tw:size-9 tw:text-lg"
      },
      "xl": {
        "root": "tw:size-10 tw:text-xl"
      },
      "2xl": {
        "root": "tw:size-11 tw:text-[22px]"
      },
      "3xl": {
        "root": "tw:size-12 tw:text-2xl"
      }
    }
  },
  "defaultVariants": {
    "size": "md" as typeof size[number]
  }
}